import ReactDOM from "react-dom/client";
import App from "app/App";
import "styles/index.scss";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
